<template>
  <div id="data-list-list-view" class="data-list-container">
    <vs-popup class="items-no-padding" :title="$t('Create_a_batch_of_students')" :active.sync="popupActive1">

      <div class="upload-img mt-5 mb-2">
        <vs-button icon-pack="feather" icon="icon-plus" @click="$refs.updateImgInput1.click()">{{ $t('upload') }}</vs-button>
      </div>

      <input type="file" class="hidden" ref="updateImgInput1" @change="updateCurrImg1" accept="">

      <vs-list-header icon-pack="feather" icon="icon-users" :title="$t('Create_a_batch_of_students')"></vs-list-header>
      <vs-list-item v-for="(item, index) in dataImg_information" :key="index" icon-pack="feather" icon="icon-check" :title="item.name"></vs-list-item>


      <div class="upload-img mt-5 mb-2">
        <vs-button :disabled="!dataImg_information.length" icon-pack="feather" color="success" icon="icon-check-circle" @click="createABatchOfStudents">{{ $t('Submit') }}</vs-button>
      </div>
    </vs-popup>

    <vx-card
      v-if="filter"
      ref="filterCard"
      :title="$t('Filter')"
      class="user-list-filters mb-4"
      actionButtons
      @refresh="initInput"
      @remove="resetColFilters"
    >
      <div class="vx-row">
        <div class="vx-col lg:w-1/3 md:w-1/3 sm:w-1/3 w-full">
          <p class="mb-2">{{ $t('room') }}</p>
          <v-select
            :options="salles"
            :reduce="(rep) => rep.id"
            @search="getSalle"
            :clearable="true"
            label="libelle"
            v-model="input.salle"
            class="w-full"
          />
        </div>
        <div class="vx-col lg:w-1/3 md:w-1/3 sm:w-1/3 w-full">
          <p class="mb-2">{{ $t('class') }}</p>
          <v-select
            :options="classes"
            :reduce="(rep) => rep.id"
            @search="getClasse"
            :clearable="true"
            label="libelle"
            v-model="input.salle__classe"
            class="w-full"
          />
        </div>
        <div class="vx-col lg:w-1/3 md:w-1/3 sm:w-1/3 w-full">
          <p class="mb-2">{{ $t('level') }}</p>
          <v-select
            :options="niveaus"
            :reduce="(rep) => rep.id"
            @search="getNiveau"
            :clearable="true"
            label="libelle"
            v-model="input.salle__classe__niveau"
            class="w-full"
          />
        </div>
      </div>
    </vx-card>

    <vs-table
      :noDataText="$t('No_data_Available')"
      ref="table"
      :data="inscriptions"
    >
      <div
        slot="header"
        class="flex flex-wrap-reverse items-center flex-grow justify-between"
      >
        <div
          class="flex flex-wrap-reverse items-center data-list-btn-container"
        >
          <!-- ACTION - DROPDOWN -->
          <vs-dropdown
            vs-trigger-click
            class="dd-actions cursor-pointer mr-4 mb-4"
          >
            <div
              class="p-4 shadow-drop rounded-lg d-theme-dark-bg cursor-pointer flex items-center justify-center text-lg font-medium w-32 w-full"
            >
              <span class="mr-2">Actions</span>
              <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
            </div>

            <vs-dropdown-menu> 
              <!-- <vs-dropdown-item @click="input.salle ? listOfStudents(input.salle) : '' " :style=" input.salle ? '' : 'cursor: not-allowed;'"> -->
              <!-- <vs-dropdown-item @click="popupActive1=true">
                <span class="flex items-center">
                  <feather-icon icon="FilePlusIcon" svgClasses="h-4 w-4" class="mr-2" />
                  <span>{{ $t("Create_a_batch_of_students") }}</span>
                </span>
              </vs-dropdown-item>

              <vs-dropdown-item @click="createElevesExcelFiles()">
                <span class="flex items-center">
                  <feather-icon icon="FilePlusIcon" svgClasses="h-4 w-4" class="mr-2" />
                  <span>{{ $t("Excel_file_header") }}</span>
                </span>
              </vs-dropdown-item> -->

              <vs-dropdown-item @click="input.salle ? listOfStudents(input.salle) : '' " v-if="input.salle">
                <span class="flex items-center">
                  <feather-icon icon="FilePlusIcon" svgClasses="h-4 w-4" class="mr-2" />
                  <span>{{ $t("list_of_students") }}</span>
                </span>
              </vs-dropdown-item>

              <vs-dropdown-item @click="input.salle ? noteCard(input.salle) : '' " v-if="input.salle">
                <span class="flex items-center">
                  <feather-icon icon="FileIcon" svgClasses="h-4 w-4" class="mr-2" />
                  <span>{{ $t("note_card") }}</span>
                </span>
              </vs-dropdown-item>

              <vs-dropdown-item @click="input.salle ? attendanceRecord(input.salle) : '' " v-if="input.salle">
                <span class="flex items-center">
                  <feather-icon icon="SaveIcon" svgClasses="h-4 w-4" class="mr-2" />
                  <span>{{ $t("attendance_record") }}</span>
                </span>
              </vs-dropdown-item>
            </vs-dropdown-menu>
          </vs-dropdown>

          <div
            class="btn-add-new p-3 mb-4 mr-4 rounded-lg cursor-pointer flex items-center justify-center text-lg font-medium text-base text-primary border border-solid border-primary"
            @click="addNewStudent"
          >
            <feather-icon icon="PlusIcon" svgClasses="h-4 w-4" />
            <span class="ml-2 text-base text-primary">{{ $t('add') }}</span>
          </div>

          <vx-tooltip :text="$t('Filterlist')" color="warning">
            <div
              class="btn-add-new p-4 mb-4 mr-4 rounded-lg cursor-pointer flex items-center justify-center text-lg font-medium text-base text-warning border border-solid border-warning"
              @click="filter = !filter"
            >
              <feather-icon icon="FilterIcon" svgClasses="h-4 w-4" />
            </div>
          </vx-tooltip>
        </div>
        <ul class="demo-alignment">
            <li>
              <vs-checkbox v-model="girl">{{$t('Girls')}}</vs-checkbox>
            </li>
            <li>
              <vs-checkbox color="success" v-model="boy">{{$t('Boys')}}</vs-checkbox>
            </li>
        </ul>
        <div class="flex flex-wrap">
          <!-- ITEMS PER PAGE -->
          <vs-dropdown vs-trigger-click class="cursor-pointer mb-4 mr-4">
            <div
              class="p-4 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium"
            >
              <span class="mr-2">
                {{
                  param.paginate.page * param.paginate.length -
                  (param.paginate.length - 1)
                }}
                -
                {{
                  taille - param.paginate.page * param.paginate.length > 0
                    ? param.paginate.page * param.paginate.length
                    : taille
                }}
                {{ $t('of_sur') }} {{ taille }}
              </span>
              <feather-icon icon="ChevronDownIcon" svgInscriptions="h-4 w-4" />
            </div>

            <vs-dropdown-menu>
              <vs-dropdown-item
                :key="indexItem"
                v-for="(item, indexItem) in itemsPerPages"
                @click=";(param.paginate.length = item), getInscriptions()"
              >
                <span>{{ item }}</span>
              </vs-dropdown-item>
            </vs-dropdown-menu>
          </vs-dropdown>

          <vs-input
            icon-pack="feather"
            icon="icon-search"
            :placeholder="$t('Search')"
            v-model="search"
            class="is-label-placeholder mb-8"
          />
        </div>
      </div>

      <template slot="thead">
        <vs-th> {{ $t('Picture') }} </vs-th>
        <vs-th sort-key="eleve.matricule"> {{ $t('Registration_number') }} </vs-th>
        <vs-th sort-key="eleve.full_name">{{ $t('full_name') }}</vs-th>
        <vs-th sort-key="statutEleve.libelle">{{ $t('Student_status') }}</vs-th>
        <!-- <vs-th sort-key="eleve.dateEntree">{{ $t('Entry_date') }}</vs-th> -->
        <!-- <vs-th sort-key="eleve.naissance">{{ $t('Date_of_Birth') }}</vs-th> -->
        <vs-th sort-key="eleve.sexe.code">{{ $t('sex') }}</vs-th>
        <vs-th
          v-if="!input.salle"
          sort-key="salle.libelle">{{ $t('Classroom') }}</vs-th>
        <vs-th>{{ $t('action') }}</vs-th>
      </template>
      <template slot-scope="{ data }">
        <tbody>
          <vs-tr
            :data="tr"
            :key="indextr"
            v-for="(tr, indextr) in data"
            :class="(tr.abandonAtente || tr.abandon) ? 'is-selected' : ''"
          >
            <vs-td class="p-0">
              <vs-avatar
                v-if="tr.eleve.photo"
                size="50px" :src="seePicture(tr.eleve.photo.url)" class="m-1" @click="indextr__id = indextr, uploadPhoto = '', selectedEleve = tr.eleve, popupActive = true"/>
            </vs-td>

            <vs-td>
              <p class="product-name font-medium truncate">
                {{ tr.eleve.matricule }}
              </p>
            </vs-td>

            <vs-td>
              <p class="product-name font-medium truncate">
                {{ tr.eleve.full_name }}
              </p>
            </vs-td>

            <vs-td>
              <p class="product-name font-medium truncate">
                {{ tr.statutEleve.libelle }}
              </p>
            </vs-td>

            <!-- <vs-td>
              <p class="product-name font-medium truncate">
                {{
                  $store.state.convertDateTime(new Date(tr.eleve.dateEntree))
                    .date
                }}
              </p>
            </vs-td> -->

            <!-- <vs-td>
              <p class="product-name font-medium truncate">
                {{
                  $store.state.convertDateTime(new Date(tr.eleve.naissance))
                    .date
                }}
              </p>
            </vs-td> -->

            <vs-td>
              <p class="product-name font-medium truncate">
                {{ tr.eleve.sexe ? tr.eleve.sexe.code : '' }}
              </p>
            </vs-td>

            <vs-td
              v-if="!input.salle"
            >
              <p class="product-name font-medium truncate">
                {{ tr.salle.libelle }}
              </p>
            </vs-td>

            <vs-td class="whitespace-no-wrap">
              <div class="flex">
                <vx-tooltip :text="$t('Upload_picture')" color="success">
                  <feather-icon
                    @click="indextr__id = indextr, uploadPhoto = '', selectedEleve = tr.eleve, popupActive = true"
                    style="color: #28c76f;"
                    icon="UploadCloudIcon"
                    svgClasses="w-5 h-5 hover:text-success stroke-current"
                    class="mr-2"
                  />
                </vx-tooltip>

                <vx-tooltip
                  v-if="false"
                  :text="$t('Profile')"
                  color="rgb(103, 201, 247)"
                >
                  <feather-icon
                    style="color: rgb(103, 201, 247);"
                    icon="EyeIcon"
                    svgClasses="w-5 h-5 hover:text-default stroke-current"
                    class="mr-2"
                    @click="profile(tr.id)"
                  />
                </vx-tooltip>

                <vx-tooltip :text="$t('update')" color="warning">
                  <feather-icon
                    style="color: #ff9f43;"
                    icon="EditIcon"
                    svgClasses="w-5 h-5 hover:text-warning stroke-current"
                    class="mr-2"
                    @click="edit(tr.id)"
                  />
                </vx-tooltip>
                <vx-tooltip :text="$t('Delete')" color="danger">
                  <feather-icon
                    @click="inscription_delete(tr.id)"
                    style="color: red;"
                    icon="TrashIcon"
                    svgClasses="w-5 h-5 hover:text-danger stroke-current"
                    class="mr-2"
                  />
                </vx-tooltip>
                <vx-tooltip
                  :text="$t('Abandonment')"
                  color="olive"
                  v-if="!tr.abandonAtente && !tr.abandon"
                >
                  <feather-icon
                    @click="abandon_eleve(tr)"
                    style="color: olive;"
                    icon="UserXIcon"
                    svgClasses="w-5 h-5 hover:text-default stroke-current"
                    class="mr-2"
                  />
                </vx-tooltip>
              </div>
            </vs-td>
          </vs-tr>
        </tbody>
      </template>
    </vs-table>
    <div class="items-center">
      <vs-pagination :total="total" v-model="currentPage"></vs-pagination>
    </div>
    <vs-popup
      class="items-no-padding"
      :title="$t('Upload_picture')"
      :active.sync="popupActive"
    >
      <template v-if="uploadPhoto || (selectedEleve && selectedEleve.photo)">
        <!-- Image Container -->
        <div class="img-container w-104 mx-auto flex items-center justify-center">
          <img v-if="uploadPhoto" :src="uploadPhoto" alt="img" class="responsive" />
          <img v-if="selectedEleve.photo && !uploadPhoto" :src="seePicture(selectedEleve.photo.url)" alt="img" class="responsive" />
        </div>

        <!-- Image upload Buttons -->
        <div class="modify-img flex justify-between mt-5">
          
          <vs-button
            class="mr-4"
            type="flat"
            @click="$refs.updateImgInput.click()"
          >
            {{ $t('Update_image') }}
          </vs-button>
          <vs-button type="flat" color="#999" @click="uploadPhoto = null, removeImage()">
            {{ $t('Remove_image') }}
          </vs-button>
        </div>
      </template>
      <div class="upload-img mt-5">
        <input
          type="file"
          class="hidden"
          ref="updateImgInput"
          @change="updateCurrImg"
          accept="image/*"
        />
        <vs-button
          v-if="!uploadPhoto && selectedEleve && !selectedEleve.photo"
          @click="$refs.updateImgInput.click()"
        >
          {{ $t('Upload_image') }}
        </vs-button>
      </div>
      <div class="upload-img mt-5 mb-2">
        <vs-button
          :disabled="!uploadPhoto"
          icon-pack="feather"
          color="success"
          icon="icon-check-circle"
          @click="uploadStudentPhoto"
        >
          {{ $t('Submit') }}
        </vs-button>
      </div>
    </vs-popup>
  </div>
</template>

<script>
let base_self = ''
import moduleDataList from '@/store/data-list/moduleDataList.js'

// Inscription
const input_tempon = {
  salle: '',
  salle__classe: '',
  salle__classe__niveau: '',
  statutEleve: '',
  anneeScolaire: '',
  sexe: '',
  parents: []
}

export default {
  components: {},
  data () {
    return {
      girl: false,
      boy: false,
      indextr__id: 0,
      uploadPhoto: '',
      dataImg1: [],
      dataImg_information: [],
      selectedEleve: null,
      niveaus: [],
      salles: [],
      popupActive: false,
      popupActive1: false,
      classes: [],
      input: JSON.parse(JSON.stringify(input_tempon)),
      input1: JSON.parse(JSON.stringify(input_tempon)),
      filter: true,
      search: '',
      param: {},
      itemsPerPages: this.$store.state.itemsPerPages,
      taille: 0,
      currentPage: 1,
      selected: [],
      inscriptions: [],
      isMounted: false,
      sidebarData: {}
    }
  },
  watch: {
    girl () {
      base_self.getInscriptions()
    },
    boy () {
      base_self.getInscriptions()
    },
    popupActive1 (value) {
      if (!value) {
        base_self.dataImg1 = []
        base_self.dataImg_information = []
      }
    },
    popupActive (value) {
      if (!value) {
        base_self.dataImg1 = []
        base_self.dataImg_information = []
      }
    },
    input: {
      handler () {
        if (base_self.input1.salle !== base_self.input.salle) {
          if (!base_self.input.salle || base_self.input.salle === '') {
            delete base_self.param.filter['salle']
          } else {
            base_self.param.filter['salle'] = base_self.input.salle
          }
        }

        if (base_self.input1.salle__classe !== base_self.input.salle__classe) {
          if (
            !base_self.input.salle__classe ||
            base_self.input.salle__classe === ''
          ) {
            delete base_self.param.filter['salle__classe']
          } else {
            base_self.param.filter['salle__classe'] =
              base_self.input.salle__classe
          }
        }

        if (
          base_self.input1.salle__classe__niveau !==
          base_self.input.salle__classe__niveau
        ) {
          if (
            !base_self.input.salle__classe__niveau ||
            base_self.input.salle__classe__niveau === ''
          ) {
            delete base_self.param.filter['salle__classe__niveau']
          } else {
            base_self.param.filter['salle__classe__niveau'] =
              base_self.input.salle__classe__niveau
          }
        }

        base_self.input1 = JSON.parse(JSON.stringify(base_self.input))
        base_self.getInscriptions()
      },
      deep: true
    },
    currentPage (value) {
      base_self.param.paginate.page = value
      base_self.getInscriptions()
    },
    search (value) {
      if (value.length) {
        base_self.param.filter.q_list = [
          { eleve__matricule__icontains: value },
          { eleve__full_name__icontains: value },
          { statutEleve__libelle__icontains: value },
          { eleve__dateEntree__icontains: value },
          { eleve__naissance__icontains: value },
          { eleve__sexe__code__icontains: value },
          { salle__libelle__icontains: value }
        ]
      } else {
        base_self.param.filter.q_list = []
      }
      base_self.getInscriptions()
    }
  },
  computed: {
    total () {
      return Math.ceil(base_self.taille / base_self.param.paginate.length)
    }
  },
  methods: {
    noteCard (id) {
      window.open(`${base_self.$http.defaults.baseURL}${base_self.$store.state.route_for_esm}pdf/fiche_de_note_by_salle/${id}`, '_blank')
    },
    attendanceRecord (id) {
      window.open(`${base_self.$http.defaults.baseURL}${base_self.$store.state.route_for_esm}pdf/fiche_presence_by_salle/${id}`, '_blank')
    },
    listOfStudents (id) {
      window.open(`${base_self.$http.defaults.baseURL}${base_self.$store.state.route_for_esm}pdf/liste_eleve_by_salle/${id}`, '_blank')
    },
    createElevesExcelFiles () {
      window.open(`${base_self.$http.defaults.baseURL}${base_self.$store.state.route_for_esm}create-eleves-excel-files`, '_blank')
    },
    seePicture (link) {
      if (!link) return ''

      link = link.substring(1)
      return `${base_self.$http.defaults.baseURL}${base_self.$store.state.route_for_esm}${link}`
    },
    updateCurrImg1 (input) {
      if (input.target.files && input.target.files[0]) {
        const length = input.srcElement.files.length
        for (let iuoy = 0; iuoy < length; iuoy++) {
          const reader = new FileReader()
          reader.onload = e => {
            // unshift
            base_self.dataImg1.unshift(e.target.result)
            base_self.dataImg_information.unshift(base_self.$refs.updateImgInput1.files[iuoy])
          }
          reader.readAsDataURL(input.target.files[iuoy])
        }
      }
    },
    updateCurrImg (input) {
      if (input.target.files && input.target.files[0]) {
        const length = input.srcElement.files.length
        for (let iuoy = 0; iuoy < length; iuoy++) {
          const reader = new FileReader()
          reader.onload = e => {
            // unshift
            base_self.uploadPhoto = e.target.result
            base_self.dataImg1.unshift(e.target.result)
            base_self.dataImg_information.unshift(base_self.$refs.updateImgInput.files[iuoy])
          }
          reader.readAsDataURL(input.target.files[iuoy])
        }
      }
    },
    createABatchOfStudents () {
      base_self.$vs.loading()
      const form = new FormData()

      form.append('file', base_self.dataImg_information[0], base_self.dataImg_information[0].name)

      base_self.$http.post(`${base_self.$store.state.route_for_esm}read-eleves-excel-files`, form)
        .then((response) => {
          console.log('response: ', response)

          window.getESM.success(base_self.$t('The_matter_type_is_changed_successfully'), response)
          base_self.popupActive1 = false
          base_self.$vs.loading.close()
        })
        .catch((error) => {
          console.log('error: ', error)
          base_self.$vs.loading.close()
        })

      base_self.popupActive = false
    },
    addNewStudent () {
      base_self.$router.push(`/Student_management/Student/${0}`).catch(() => {})
    },
    removeImage () {
      // photo
      if (!base_self.selectedEleve.id) return

      base_self.$vs.loading()
      /* const data = {
        id: base_self.selectedEleve.id,
        photo: ''
      } */

      base_self.$http
        .get(`${base_self.$store.state.route_for_esm}supprimer-une-photo/${base_self.selectedEleve.id}`)
        .then((response) => {
          console.log('response: ', response)

          window.getESM.success(
            base_self.$t('The_picture_is_changed_successfully'),
            response,
          )
          base_self.popupActive = false
          base_self.$vs.loading.close()
        })
        .catch((error) => {
          console.log('error: ', error)
          base_self.$vs.loading.close()
        })

      base_self.popupActive = false
    },
    uploadStudentPhoto () {
      base_self.$vs.loading()
      const form = new FormData()
      form.append('id', base_self.selectedEleve.id)
      
      const length = base_self.dataImg_information.length
      for (let iuoy = 0; iuoy < length; iuoy++) {
        console.log(base_self.dataImg_information[iuoy].name)
        form.append('photo', base_self.dataImg_information[iuoy], base_self.dataImg_information[iuoy].name)
      }

      base_self.$http
        .put(`${base_self.$store.state.route_for_esm}Eleve`, form)
        .then((response) => {
          // console.log('response: ', response.data.data.photo)
          base_self.inscriptions[base_self.indextr__id].eleve.photo = response.data.data.photo

          window.getESM.success(
            base_self.$t('The_picture_is_changed_successfully'),
            response,
          )
          base_self.popupActive = false
          base_self.$vs.loading.close()
        })
        .catch((error) => {
          console.log('error: ', error)
          base_self.$vs.loading.close()
        })

      base_self.popupActive = false
    },
    initInput () {
      base_self.input = JSON.parse(JSON.stringify(input_tempon))
      base_self.$refs.filterCard.removeRefreshAnimation()
    },
    getSalleSimple () {
      const data = {
        is_get: true,
        paginate: {
          length: 50,
          page: 1
        },
        filter: {
          is_active: true,
          classe__is_active: true,
          classe__niveau__is_active: true
        },
        orderby: ['ordre'],
        exclude: { code: 'Attente' }
      }
      base_self.$http
        .post(`${base_self.$store.state.route_for_esm}Salle`, data)
        .then((response) => {
          base_self.salles = response.data.data
        })
        .catch((error) => {
          console.log('error: ', error)
        })
    },
    getSalle (search, loading) {
      loading(true)
      const data = {
        is_get: true,
        paginate: {
          length: 50,
          page: 1
        },
        filter: {
          is_active: true,
          classe__is_active: true,
          classe__niveau__is_active: true,
          libelle__icontains: search
        },
        orderby: ['ordre'],
        exclude: { code: 'Attente' }
      }
      base_self.$http
        .post(`${base_self.$store.state.route_for_esm}Salle`, data)
        .then((response) => {
          base_self.salles = response.data.data
          loading(false)
        })
        .catch((error) => {
          loading(false)
          console.log('error: ', error)
        })
    },
    getClasseSimple () {
      const data = {
        is_get: true,
        paginate: {
          length: 50,
          page: 1
        },
        filter: { is_active: true, niveau__is_active: true },
        orderby: ['ordre']
      }
      base_self.$http
        .post(`${base_self.$store.state.route_for_esm}Classe`, data)
        .then((response) => {
          base_self.classes = response.data.data
        })
        .catch((error) => {
          console.log('error: ', error)
        })
    },
    getClasse (search, loading) {
      loading(true)
      const data = {
        is_get: true,
        paginate: {
          length: 50,
          page: 1
        },
        filter: {
          is_active: true,
          niveau__is_active: true,
          libelle__icontains: search
        },
        orderby: ['ordre']
      }
      base_self.$http
        .post(`${base_self.$store.state.route_for_esm}Classe`, data)
        .then((response) => {
          base_self.classes = response.data.data
          loading(false)
        })
        .catch((error) => {
          loading(false)
          console.log('error: ', error)
        })
    },
    getNiveauSimple () {
      const data = {
        is_get: true,
        paginate: {
          length: 50,
          page: 1
        },
        filter: { is_active: true }
      }
      base_self.$http
        .post(`${base_self.$store.state.route_for_esm}Niveau`, data)
        .then((response) => {
          base_self.niveaus = response.data.data
        })
        .catch((error) => {
          console.log('error: ', error)
        })
    },
    getNiveau (search, loading) {
      loading(true)
      const data = {
        is_get: true,
        paginate: {
          length: 50,
          page: 1
        },
        filter: { is_active: true, libelle__icontains: search }
      }
      base_self.$http
        .post(`${base_self.$store.state.route_for_esm}Niveau`, data)
        .then((response) => {
          base_self.niveaus = response.data.data
          loading(false)
        })
        .catch((error) => {
          loading(false)
          console.log('error: ', error)
        })
    },
    resetColFilters () {
      this.$refs.filterCard.removeRefreshAnimation()
    },
    edit (id) {
      base_self.$router
        .push(`/Student_management/Student/${id}`)
        .catch(() => {})
    },
    profile (id) {
      base_self.$router
        .push(`/Student_management/Student/Profile/${id}`)
        .catch(() => {})
    },
    async inscription_delete (id) {
      this.$vs.dialog({
        type: 'confirm',
        color: 'danger',
        title: base_self.$t('Confirmation'),
        text: base_self.$t('Confirm_deletion'),
        acceptText: base_self.$t('Confirm'),
        cancelText: 'Cancel',
        accept: async () => {
          // console.log('id: ', id)
          const params = {
            id
          }

          base_self.$http
            .delete(`${base_self.$store.state.route_for_esm}Inscription`, {
              params
            })
            .then((response) => {
              window.getESM.success(
                base_self.$t('The_class_is_deleted_successfully'),
                response,
              )
            })
            .catch(() => {
              window.getESM.error(base_self.$t('Class_removal_failed'))
            })
        }
      })
    },
    async abandon_eleve (inscription) {
      this.$vs.dialog({
        type: 'confirm',
        color: 'danger',
        title: base_self.$t('Confirmation'),
        text: base_self.$t('Confirm_abandonment'),
        acceptText: base_self.$t('Confirm'),
        cancelText: 'Cancel',
        accept: async () => {
          const input = {
            id: inscription.id,
            abandonAtente: true
          }
          base_self.$http
            .put(`${base_self.$store.state.route_for_esm}Inscription`, input)
            .then((response) => {
              window.getESM.success(
                base_self.$t('The_abandonment_is_saved_successfully'),
                response,
              )
            })
            .catch(() => {
              window.getESM.error(base_self.$t('Abandonment_saving_failed'))
            })
        }
      })
    },
    async getInscriptions () {
      base_self.$vs.loading()
      
      if (base_self.boy && base_self.girl) {
        delete base_self.param.filter['eleve__sexe__code']
      } else if (base_self.boy) {
        base_self.param.filter['eleve__sexe__code'] = 'M'
      } else if (base_self.girl) {
        base_self.param.filter['eleve__sexe__code'] = 'F'
      } else {
        delete base_self.param.filter['eleve__sexe__code']
      }

      base_self.$http
        .post(
          `${base_self.$store.state.route_for_esm}Inscription`,
          base_self.param,
        )
        .then((response) => {
          base_self.inscriptions = response.data.data
          base_self.taille = response.data.taille
          base_self.$vs.loading.close()
        })
        .catch(() => {
          window.getESM.error(base_self.$t('The_server_is_not_responding'))
          base_self.$vs.loading.close()
        })
    },
    InscriptionWebSocket () {
      base_self.$store.state.webSocketFunction(base_self, 'inscription')
    }
  },
  created () {
    base_self = this
    base_self.param = JSON.parse(JSON.stringify(base_self.$store.state.paramInscription))

    const id = Number(base_self.$route.params.id)
    if (id === 1) {
      base_self.girl = true
    } else if (id === 2) {
      base_self.boy = true
    } else {
      base_self.boy = true
      base_self.girl = true
    }
    
    base_self.InscriptionWebSocket()
    base_self.getInscriptions()
    base_self.getNiveauSimple()
    base_self.getClasseSimple()
    base_self.getSalleSimple()

    if (!moduleDataList.isRegistered) {
      this.$store.registerModule('dataList', moduleDataList)
      moduleDataList.isRegistered = true
    }
    this.$store.dispatch('dataList/fetchDataListItems')
  },
  mounted () {
    this.isMounted = true
  }
}
</script>

<style>
.vs-input--input {
  border-radius: 20px;
  padding: 0.9rem 2.5rem;
  font-size: 1rem;
}
</style>

<style lang="scss">
#data-list-list-view {
  .vs-con-table {
    .product-name {
      max-width: 23rem;
    }

    .vs-table--header {
      display: flex;
      flex-wrap: wrap-reverse;
      margin-left: 1.5rem;
      margin-right: 1.5rem;
      > span {
        display: flex;
        flex-grow: 1;
      }

      .vs-table--search {
        padding-top: 0;

        .vs-table--search-input {
          padding: 0.9rem 2.5rem;
          font-size: 1rem;

          & + i {
            left: 1rem;
          }

          &:focus + i {
            left: 1rem;
          }
        }
      }
    }

    .vs-table {
      border-collapse: separate;
      border-spacing: 0 1.3rem;
      padding: 0 1rem;

      tr {
        box-shadow: 0 4px 20px 0 rgba(0, 0, 0, 0.05);
        td {
          padding: 20px;
          &:first-child {
            border-top-left-radius: 0.5rem;
            border-bottom-left-radius: 0.5rem;
          }
          &:last-child {
            border-top-right-radius: 0.5rem;
            border-bottom-right-radius: 0.5rem;
          }
        }
        td.td-check {
          padding: 20px !important;
        }
      }
    }

    .vs-table--thead {
      th {
        padding-top: 0;
        padding-bottom: 0;

        .vs-table-text {
          text-transform: uppercase;
          font-weight: 600;
        }
      }
      th.td-check {
        padding: 0 15px !important;
      }
      tr {
        background: none;
        box-shadow: none;
      }
    }

    .vs-table--pagination {
      justify-content: center;
    }
  }
}
</style>
